import styled from 'styled-components';
import photo from 'assets/images/photo-5.jpg';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
`;

export const PhotoWrapper = styled.div`
  height: 100%;
  position: relative;
`;

export const Photo = styled.img.attrs({ src: photo })`
  width: auto;
  height: 100%;
  object-fit: contain;
`;

export const Credit = styled.article`
  width: 136px;
  font-size: 12px;
  line-height: 17px;
  position: absolute;
  bottom: 72px;
  right: -190px;
  color: #000;

  @media screen and (max-width: 1440px) {
    right: -155px;
  }
  @media screen and (max-width: 1024px) {
    right: 32px;
  }
`;
